import { RouteRecordRaw } from "vue-router";
import PersonRegistrationLaunchView from "@/apps/core-app-onboarding/views/PersonRegistrationLaunchView.vue";
import PersonRegistrationCompleteView from "@/apps/core-app-onboarding/views/PersonRegistrationCompleteView.vue";
import PersonRegistrationTagLoginView from "@/apps/core-app-onboarding/views/PersonRegistrationTagLoginView.vue";
import CheckSignatureView from "@/apps/core-app-onboarding/views/CheckSignatureView.vue";
import ComingSoonView from "@/apps/core-app-onboarding/views/ComingSoonView.vue";
import LocationPickerView from "@/apps/core-app-onboarding/views/LocationPickerView.vue";
import InitView from "@/apps/core-app-onboarding/views/InitView.vue";
import NotAvailableView from "@/apps/core-app-onboarding/views/NotAvailableView.vue";
import OpenMarketRegistrationView from "@/apps/core-app-onboarding/views/OpenMarketRegistrationView.vue";
import { coreAppOnboardingTranslationGuard } from "@/router/translationGuards";

const enableRUMMeta = { enableRUM: true };

const basePath =
  process.env.VUE_APP_BUILD_TYPE === "core-app-onboarding"
    ? ""
    : "/core-app-onboarding";
const routes: Array<RouteRecordRaw> = [
  {
    path: `${basePath}/init`,
    name: "InitView",
    component: InitView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/pr/launch`,
    name: "PersonRegistrationLaunchView",
    component: PersonRegistrationLaunchView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/pr/complete`,
    name: "PersonRegistrationCompleteView",
    component: PersonRegistrationCompleteView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/registration-tag/login`,
    name: "PersonRegistrationTagLoginView",
    component: PersonRegistrationTagLoginView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/credit-pull`,
    name: "CreditPull",
    component: CheckSignatureView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/coming-soon`,
    name: "ComingSoonView",
    component: ComingSoonView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/location-picker`,
    name: "LocationPickerView",
    component: LocationPickerView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/not-available`,
    name: "NotAvailableView",
    component: NotAvailableView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
  {
    path: `${basePath}/registration`,
    name: "OpenMarketRegistrationView",
    component: OpenMarketRegistrationView,
    beforeEnter: [coreAppOnboardingTranslationGuard],
  },
].map((route) => ({ ...route, meta: enableRUMMeta }));

export default routes;
